const regexp = new RegExp(/^(\+7|7|8)/)
const replacedSymbol = '7'

export function formatPhone(phone?: string): string {
    if (!phone) return ''
    return phone.replace(regexp, replacedSymbol)
}
